import React, { useCallback, useLayoutEffect, useState } from 'react';

export type UseResizeObservertype = (
  ref: React.RefObject<HTMLElement>,
  boxModel?: 'border' | 'content'
) => { width: number; height: number };

const useResizeObserver: UseResizeObservertype = (ref, boxModel = 'border') => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const handleResize = useCallback(
    (entries) => {
      if (!Array.isArray(entries)) {
        return;
      }
      const entry = entries[0];

      if (boxModel === 'content') {
        setDimensions({
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        });
      } else {
        setDimensions({
          width: entry.target.getBoundingClientRect().width,
          height: entry.target.getBoundingClientRect().height,
        });
      }
    },
    [boxModel]
  );

  useLayoutEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    // @ts-ignore typescript supports this typing since at least v4.2.3
    const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => handleResize(entries), 50);
    });

    if (ref.current) observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return dimensions;
};

export default useResizeObserver;
